

export const relativeData = {
    zh_CN: {
        relative: [
            {
                value: 'Parent, incl step-parent or adoptive parent',
                label: '父母，包括继父母或领养父母'
            },
            {
                value: 'Spouse',
                label: '配偶'
            },
            {
                value: 'Party to union of concubinage',
                label: '夫妾关系的一方'
            },
            {
                value: 'Cohabitee',
                label: '同居伴侣'
            },
            {
                value: "Spouse's parent, incl step-parent or adoptive parent",
                label: '配偶的父母，包括继父母或领养父母'
            },
            {
                value: 'Child, incl step child or adopted child',
                label: '子女，包括继子女或领养子女'
            },
        ]
    },
    zh_HK: {
        relative: [
            {
                value: 'Parent, incl step-parent or adoptive parent',
                label: '父母，包括繼父母或領養父母'
            },
            {
                value: 'Spouse',
                label: '配偶'
            },
            {
                value: 'Party to union of concubinage',
                label: '夫妾關係的一方'
            },
            {
                value: 'Cohabitee',
                label: '同居伴侶'
            },
            {
                value: "Spouse's parent, incl step-parent or adoptive parent",
                label: '配偶的父母，包括繼父母或領養父母'
            },
            {
                value: 'Child, incl step child or adopted child',
                label: '子女，包括繼子女或領養子女'
            },
        ]
    },
    en: {
        relative: [
            {
                value: 'Parent, incl step-parent or adoptive parent',
                label: 'Parent, incl step-parent or adoptive parent',
            },
            {
                value: 'Spouse',
                label: 'Spouse'
            },
            {
                value: 'Party to union of concubinage',
                label: 'Party to union of concubinage'
            },
            {
                value: 'Cohabitee',
                label: 'Cohabitee'
            },
            {
                value: "Spouse's parent, incl step-parent or adoptive parent",
                label: "Spouse's parent, incl step-parent or adoptive parent"
            },
            {
                value: 'Child, incl step child or adopted child',
                label: 'Child, incl step child or adopted child'
            },
        ]
    }
}